import React, { PropTypes } from 'react';
import { Candidates, RepublicanDelegateCount, DemocraticDelegateCount } from '../helpers/constants';
import Profile from './Profile.js';

const Results = React.createClass({
  displayName: "Results",

  propTypes: {
    data: PropTypes.array
  },

  render() {
    //Do not render anything if data is missing
    if(!this.props.data[0].done) {
      return false;
    }

    function createProfileDem(d) {
      return <Profile person={d} party="d" key={d.name} showingPercentage={false} />;
    }

    function createProfileRep(d) {
      return <Profile person={d} party="r" key={d.name} showingPercentage={false} />;
    }

    const css = require('./Results.scss');
    const {data} = this.props;

    return (
      <div>
        <div style={{overflow: 'hidden', marginBottom: '1rem'}}>
          <h3 className={css.header}>Ställning</h3>
          <p><span className={css.timelabel}>Uppdaterad:</span> 15 juni 2016 - 09:15</p>
        </div>

        <section className={css.wrapper}>
          <div className={css.row}>
            {data.highScore.republicans.slice(0,3).map(createProfileRep.bind(this))}
          </div>
          <p className={css.delegateCount}><b>Republikanerna: </b>Klara delegater: <span className={css.republicanDelegates}>{data.delegateSum.republicans}</span> av {RepublicanDelegateCount}.</p>
        </section>

        <section className={css.wrapper}>
          <div className={css.row}>
            {data.highScore.democrats.map(createProfileDem.bind(this))}
          </div>
          <p className={css.delegateCount}><b>Demokraterna:</b> Klara delegater: {data.delegateSum.democrats} av {DemocraticDelegateCount}.</p>
          {/*<p className={css.test}>*Här visar vi fördelningen av räknade delegater i respektive parti. Vi begränsar antalet kandidater till de tre som fått störst stöd. Obundna delegater ingår inte i redovisningen.</p>*/}
        </section>
      </div>
    );
  }
});

export default Results;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Results.js
 **/